import { Chip } from '@aibees/shared/components';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Chip)``;
